import { GridRowId } from '@mui/x-data-grid/models/gridRows'
import { createSelector } from 'reselect'
import { TransactionsFiltersBody } from 'src/components/TransactionsListFilter/transactionsFilter.schema'
import {
  ConnectedPlatformStatus,
  TransactionExpenseCategoryStatus,
  TransactionListModel,
  TransactionListResponse,
  TransactionStatus,
} from 'src/models/transaction.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectTransactionListResponsesFromState = (
  state: RootState,
): Record<string, TransactionListResponse> =>
  state.data.transactions.listResponses
export const selectTransactionListModelsFromState = createSelector(
  [selectTransactionListResponsesFromState],
  (transactionListResponses) =>
    Object.values(transactionListResponses).reduce<
      Record<TransactionListResponse['id'], TransactionListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new TransactionListModel(curr),
      }),
      {},
    ),
)

export const selectSelectedTransactionIdsFromState = (
  state: RootState,
): Set<GridRowId> => state.data.transactions.selectedTransactions

export const selectTransactionIdsConfimingSupplierFromState = (
  state: RootState,
): string[] => state.data.transactions.transactionIdsConfirmingSupplier

export const selectSelectAllTransactionsBoxVisibleFromState = (
  state: RootState,
): boolean => state.data.transactions.selectAllTransactionsBoxVisible

export const selectSelectAllTransactionsFiltersFromState = (
  state: RootState,
): TransactionsFiltersBody | undefined =>
  state.data.transactions.selectAllTransactionsFilters

export const selectIsSelectAllTransactionsFromState = createSelector(
  [selectSelectAllTransactionsFiltersFromState],
  (selectAllTransactionFilters) => selectAllTransactionFilters !== undefined,
)

export const selectSelectAllEditableTransactionsFiltersFromState =
  createSelector(
    [selectSelectAllTransactionsFiltersFromState],
    (selectAllTransactionFilters) => ({
      ...selectAllTransactionFilters,
      syncStatuses: [
        ConnectedPlatformStatus.NotSynced,
        ConnectedPlatformStatus.Failed,
      ],
    }),
  )

export const selectSelectAllSyncableTransactionsFiltersFromState =
  createSelector(
    [selectSelectAllEditableTransactionsFiltersFromState],
    (selectAllEditableTransactionFilters) => ({
      ...selectAllEditableTransactionFilters,
      expenseCategoryStatuses: [TransactionExpenseCategoryStatus.Attached],
      status: [TransactionStatus.Cleared],
    }),
  )
